import { Component, OnDestroy, OnInit } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subscription } from 'rxjs';
import { CreateAdminDrawerComponent } from 'src/app/components/main-content/admin/manage-admins/create-admin-drawer/create-admin-drawer.component';
import { AdminService } from 'src/app/state';

@Component({
  selector: 'em-manage-admins',
  styleUrls: ['./manage-admins.component.less'],
  templateUrl: './manage-admins.component.html',
  standalone: false,
})
export class ManageAdminsComponent implements OnInit, OnDestroy {
  public admins$ = this.adminService.admins$;
  public error$ = this.adminService.error$;
  public isLoading$ = this.adminService.loading$;
  public readonly trackByRef = trackByRef;
  public deleteLoading?: string;

  private readonly subscription = new Subscription();

  public constructor(
    private readonly adminService: AdminService,
    private readonly drawerService: NzDrawerService,
    private readonly messageService: NzMessageService
  ) {}

  public ngOnInit() {
    this.subscription.add(this.adminService.load().subscribe());
  }

  public deleteAdmin(username: string) {
    this.deleteLoading = username;

    this.subscription.add(
      this.adminService.delete(username).subscribe({
        next: () => {
          this.deleteLoading = undefined;
        },
        error: (error: unknown) => {
          if (error instanceof Error) {
            this.messageService.error(error.message);
          } else {
            this.messageService.error('Unknown error occurred');
          }

          this.deleteLoading = undefined;
        },
      })
    );
  }

  public createAdmin() {
    this.drawerService.create({
      nzContent: CreateAdminDrawerComponent,
      nzTitle: 'Create new admin',
      nzWidth: 520,
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
